//Styles
import Styles from "./ActionCenter.module.scss"
import classnames from "classnames";

//Component
import { ReactNode, useEffect, useState } from "react";
import { getDateTime } from "../../../methods/getDateTime";
import { useSwipeable } from "react-swipeable";

//Icons
import { ReactComponent as BatteryIcon } from "../../../icons/common/battery.svg"
import { ReactComponent as WifiIcon } from "../../../icons/common/wifi.svg"
import { ReactComponent as SpotifyIcon } from "../../../icons/extra_icons/spotify_icon.svg"
import { ReactComponent as NetworkIcon } from "../../../icons/extra_icons/sim_network.svg"
import { ReactComponent as FiveGIcon } from "../../../icons/extra_icons/5g.svg"
import NotificationPanel from "./notification-panel/NotificationPanel";
import { getTimeInFormat } from "../../../global/functions/functrions";




//Redux

interface ActionCenterProps{
    isDragable?:boolean;
}

const ActionCenter = ({isDragable=true}:ActionCenterProps) => {

    const handlers=useSwipeable({
        onSwipedDown: isDragable ? ()=>{setIsNotificationPanelOpen(true)} : ()=>{},
        onSwipedUp: isDragable ? ()=>{setIsNotificationPanelOpen(false)} : ()=>{}
    })

    const [currentTime, setTime] = useState(new Date())
    const [isOnline,setIsOnline] = useState(!!navigator.onLine)
    const [isNotificationPanelOpen,setIsNotificationPanelOpen] = useState(false)

    useEffect(() => {
        setInterval(() => {
            setTime(new Date())
        }, 1000)
    }, [navigator])

    interface OptionType {
        id: string;
        component: any;
        subOptions?: OptionType[],
        isComponent?: boolean,
        onClick: () => void;
    }

    const leftHeaderMenu: OptionType[] = [
        {
            id: "time",
            component: <div className={Styles.date}>{getTimeInFormat(currentTime)}</div>,
            onClick: () => { }
        },
        {
            id: "spotify",
            component: <div className={Styles.medium_icon}><SpotifyIcon /></div>,
            onClick: () => { }
        },

    ]


    const rightHeaderMenu: OptionType[] = [
        {
            id: "wifi",
            component: <WifiIcon />,
            onClick: () => { },
        },
        {
            id: "five_g",
            component: <div className={Styles.small_icon}>{isOnline &&  <FiveGIcon />}</div>,
            onClick: () => { },
        },
        {
            id: "network",
            component: <div className={Styles.medium_icon}>{isOnline && <NetworkIcon />}</div>,
            onClick: () => { },
        },
        {
            id: "battery_value",
            component: <div className={Styles.date}>{`100%`}</div>,
            onClick: () => { },
        },
        {
            id: "battery",
            component: <BatteryIcon />,
            onClick: () => { },
        },

    ]


    return (
        <div className={Styles.container} {...handlers}>
            <div className={classnames(Styles.header)}>
                <div className={Styles.left_menu}>
                    {
                        leftHeaderMenu.map((option: any, index: number) => {
                            return (
                                <div
                                    key={option.id || option.label || index}
                                    className={Styles.option}
                                    onClick={option.onClick}>
                                    {option.component}
                                </div>
                            )
                        })
                    }
                </div>
                <div className={Styles.right_menu}>
                    {
                        rightHeaderMenu.map((option: any, index: number) => {
                            return (
                                <div
                                    key={option.id || option.label || index}
                                    className={Styles.option}
                                    onClick={option.onClick}>
                                    {option.component}
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            {
                isNotificationPanelOpen && <div className={Styles.panel}  ><NotificationPanel /></div>
            }
        </div>
    )
}

export default ActionCenter


